import { DateFilter, IdFilter, StringFilter } from 'core/filters';
import { ModelFilter } from 'core/models';

export class MenuReportFilter extends ModelFilter {
    public id?: IdFilter = new IdFilter();
    public code?: StringFilter = new StringFilter();
    public name?: StringFilter = new StringFilter();
    public siteId?: IdFilter = new IdFilter();
    public menuId?: IdFilter = new IdFilter();
    public updatedAt?: DateFilter = new DateFilter();
    public search?: string;
}
